import axios from "axios";
import * as ActionType from "./badge.type";
import { setToast } from "../../../util/toast";
import { apiInstanceFetch } from "../../../util/api";
import { baseURL } from "../../../util/config";
export const gettingTheBadgeUser = () => async (dispatch) => {
  let data = "";
  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${baseURL}admin/badgeuser/badge`,
    headers: {
      key: "aw6xayDawf3cUm22QtMHlxfL8lZESl0W",
    },
    data: data,
  };

  axios
    .request(config)
    .then((response) => {
      if (response.data.status) {
        // setToast("success", "successfully get the badge users");
        dispatch({
          type: ActionType.GETBADGEUSERS,
          payload: {
            badgeUser: response.data.badgeUsers,
            unBadgeUser: response.data.nonBadgeUsers,
          },
        });
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

export const setTheGoldenBadgeUser = (data) => async (dispatch) => {
  let badgeData = JSON.stringify({
    badgeUser: data.badge,
    badgeIds: data.ids,
  });
  console.log(badgeData);
  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${baseURL}admin/badgeuser/badge`,
    headers: {
      key: "aw6xayDawf3cUm22QtMHlxfL8lZESl0W",
      "Content-Type": "application/json",
    },
    data: badgeData,
  };

  axios
    .request(config)
    .then((response) => {
      console.log(response.data);
      if (response.data.status) {
        setToast("success", response.data.message);
        dispatch(gettingTheBadgeUser());
      }
    })
    .catch((error) => {
      console.log(error);
    });
};
